// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-generate-id-js": () => import("./../src/pages/generate-id.js" /* webpackChunkName: "component---src-pages-generate-id-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-station-js": () => import("./../src/templates/Station.js" /* webpackChunkName: "component---src-templates-station-js" */)
}

